module.exports = __webpack_public_path__ + "static/img/risklatte_logo.59ec54f3.png";